
        <div class="d-flex flex-column d-flex-gap">
          <div fieldmagicGridRow>
            <div fieldmagicGridColumn="12">
              <div class="w-100 d-flex d-flex-gap justify-content-end align-items-center">

                <fieldmagic-primary-button
                  variant="link"
                  [icon]="[
                    {
                      icon: 'plus-circle',
                      klass: 'text-success'
                    }
                  ]"
                  label="add_resources"
                  (click)="onClickAddResource()"
                  [disabled]="loading$ | async"
                >
                </fieldmagic-primary-button>

                <fieldmagic-primary-button
                  purpose="save"
                  (click)="onClickSave()"
                  [isInProgress]="loading$ | async"
                >
                </fieldmagic-primary-button>

              </div>
            </div>
          </div>

          <div fieldmagicGridRow>
            <div fieldmagicGridColumn="12">
              <fieldmagic-data-grid
                [columns]="columns"
                [options]="options"
                [menus]="menus"
                [fit]="true"
                (onReady)="onGridReady($event)"
              >
              </fieldmagic-data-grid>
            </div>
          </div>
        </div>
  